export default __webpack_public_path__ + "4a86a8700edda18a47694b866874e23a.gif";